import { Button } from "@mui/material";
import Backbutton from "assets/backbutton";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { routes } from "utils/routes";
import { clearFilters } from "./Filters/Filters.slice";
import Typography from "./Typography";

interface Props {
  label: string;
  isButtonVisible?: boolean;
  color?: string;
  onClick?: any;
}

export default function BackButton(props: Props) {
  const { label, isButtonVisible, color, onClick } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const isAbovePropertyUser = useAppSelector((state) => state.app.isAbovePropertyUser);
  const isAdmin = useAppSelector((state) => state.app.isAdmin);
  const [isVisible, setIsVisible] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    let links = [routes.Dashboard, routes.Library, routes.CorporateDashboard];
    if (!isAbovePropertyUser) links.push(routes.UserDashboard);
    setIsVisible(!links.includes(location.pathname));
    if (isButtonVisible) setIsVisible(true);
    if (location?.state?.backButtonVisible === false) setIsVisible(false);
  }, [location]);

  const back = () => {
    const url = String(location?.pathname?.split("/")[1])?.toLowerCase();
    navigate(-1);
    if (isAdmin && ["plandetails", "mylists"].includes(url)) dispatch(clearFilters({ skipModified: true }));
  };

  return (
    <>
      {isVisible ? (
        <Button
          sx={{ paddingLeft: "0px", gap: "8px", marginY: { xs: "0", md: "unset" } }}
          variant="text"
          onClick={onClick ?? back}
        >
          <Backbutton color={color}></Backbutton>
          <Typography color={color ?? tokens.Text.General.Secondary} children={label} variant="body1" />
        </Button>
      ) : (
        <></>
      )}
    </>
  );
}
